/* eslint-disable max-len */
import React, {
  Ref, forwardRef, useEffect, useState,
} from 'react';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
} from '@mui/material';
import {
  LeftElementAndComponent,
  METAL_CONCENTRATIONS, SOLID_PERCENTAGE, TOTAL_ACID_DESCRIPTION, VISCOSITY_DESCRIPTION, WATER_DESCRIPTION, pdfColorCode,
} from './constant';
import { debugLog } from '../Logger';
import { OilReportPdfDataResultType, TableDataType } from '../../Screens/oilReport/utils/types';
import ChartComponent from '../ChartComponent';
import severeIcon from '../../assets/Icons/OilReportPdfIcons/severe.svg';
import abnormalIcon from '../../assets/Icons/OilReportPdfIcons/abnormal.svg';
import cautiousIcon from '../../assets/Icons/OilReportPdfIcons/caution.svg';
import normalIcon from '../../assets/Icons/OilReportPdfIcons/normal.svg';
import undeterminedIcon from '../../assets/Icons/OilReportPdfIcons/undetermined.svg';
import { getBase64FromImageUrl } from '../../utils/CommonFunctions';

interface OilReportPdfModalPropType {
  show?: boolean;
  oilReportPdfData?: OilReportPdfDataResultType;
}

interface GetRectangularComponentPropType {
  leftHeading: string;
  rightHeading: string;
}

const OilReportPdfModal = forwardRef(({ show, oilReportPdfData }: OilReportPdfModalPropType, ref: Ref<HTMLDivElement>) => {
  debugLog(show);
  const bgColor = oilReportPdfData?.ColorDetails?.BackgroundColor;
  const borderColor = oilReportPdfData?.ColorDetails?.BorderColor;
  const emailAddress = 'support@taiservices.com';

  const handleEmailClick = () => {
    window.location.href = `mailto:${emailAddress}`;
  };

  const getColors = (code: string) => (
    <div style={{
      backgroundColor: code,
      width: '8px',
      height: '8px',
      borderRadius: '50%',
      border: '1px solid #000000',
    }}
    />
  );
  // eslint-disable-next-line consistent-return
  const getDotStyle = (colorCode: string) => {
    if (colorCode?.toLowerCase()
      === pdfColorCode.ABNORMAL_NEW?.toLowerCase()
      || colorCode?.toLowerCase()
      === pdfColorCode.ABNORMAL?.toLowerCase()) {
      return getColors('blue');
    }
    if (colorCode?.toLowerCase()
      === pdfColorCode.CAUTION?.toLowerCase()) {
      return getColors('yellow');
    }
    if (colorCode?.toLowerCase()
      === pdfColorCode.SEVERE?.toLowerCase()) {
      return getColors('red');
    }
    if (colorCode?.toLowerCase()
      === pdfColorCode.UNDETERMINED1?.toLowerCase()
      || colorCode?.toLowerCase()
      === pdfColorCode.UNDETERMINED2?.toLowerCase()) {
      return getColors('white');
    }
    return (
      <div style={{
        backgroundColor: '#FFFFFF',
        width: '8px',
        height: '8px',
        borderRadius: '50%',
        border: '1px solid #FFFFFF',
      }}
      />
    );
  };

  const getRectangularComponent = ({ leftHeading, rightHeading }: GetRectangularComponentPropType) => (
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
      <div
        style={{
          textAlign: 'left',
          fontSize: '11px',
          fontWeight: '500',
          border: `1px solid ${borderColor}`,
          width: '50%',
          height: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {leftHeading}
      </div>
      <div
        style={{
          textAlign: 'left',
          fontSize: '12px',
          fontWeight: '500',
          border: `1px solid ${borderColor}`,
          width: '50%',
          height: '20px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {rightHeading}
      </div>
    </div>
  );

  const renderIcon = (row: TableDataType) => {
    if (row?.Condition?.Color?.toLowerCase() === 's') {
      return (
        <div className="severeIcon">
          <img src={severeIcon} alt="" />
          <p>Severe</p>
        </div>
      );
    } if (row?.Condition?.Color?.toLowerCase() === 'ab' || row?.Condition?.Color?.toLowerCase() === 'a') {
      return (
        <div className="severeIcon">
          <img src={abnormalIcon} alt="" />
          <p>Abnormal</p>
        </div>
      );
    } if (row?.Condition?.Color?.toLowerCase() === 'c') {
      return (
        <div className="severeIcon">
          <img src={cautiousIcon} alt="" />
          <p>Caution</p>
        </div>
      );
    } if (row?.Condition?.Color?.toLowerCase() === 'o' || row?.Condition?.Color?.toLowerCase() === 'd') {
      return (
        <div className="severeIcon">
          <img src={undeterminedIcon} alt="" />
          <p>Undetermined</p>
        </div>
      );
    }
    // if (Object.values(row)?.some((item) => (item?.Color === 'S' || item?.Color === 's'))) {
    //   return (
    //     <div className="severeIcon">
    //       <img src={severeIcon} alt="" />
    //       <p>Severe</p>
    //     </div>
    //   );
    // } if (Object.values(row)?.some((item) => (item?.Color?.toLowerCase() === 'ab' || item?.Color?.toLowerCase() === 'a'))) {
    //   return (
    //     <div className="severeIcon">
    //       <img src={abnormalIcon} alt="" />
    //       <p>Abnormal</p>
    //     </div>
    //   );
    // } if (Object.values(row)?.some((item) => (item?.Color === 'C' || item?.Color === 'c'))) {
    //   return (
    //     <div className="severeIcon">
    //       <img src={cautiousIcon} alt="" />
    //       <p>Caution</p>
    //     </div>
    //   );
    // } if (Object.values(row)?.some((item) => (item?.Color?.toLowerCase() === 'o' || item?.Color?.toLowerCase() === 'd'))) {
    //   return (
    //     <div className="severeIcon">
    //       <img src={cautiousIcon} alt="" />
    //       <p>Undetermined</p>
    //     </div>
    //   );
    // }
    return (
      <div className="severeIcon">
        <img src={normalIcon} alt="" />
        <p>Normal</p>
      </div>
    );
  };

  const [base64Logo, setBase64Logo] = useState<string>();

  useEffect(() => {
    const convertLogo = async () => {
      if (oilReportPdfData?.ColorDetails?.LogoLink) {
        const base64 = await getBase64FromImageUrl(oilReportPdfData.ColorDetails.LogoLink);
        setBase64Logo(base64);
      }
    };
    convertLogo();
  }, [oilReportPdfData?.ColorDetails?.LogoLink]);

  const oilReportFirstPage = () => (
    <>
      <div style={{
        padding: '10px 20px 3px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center',
      }}
      >
        <div>
          <img src={base64Logo} style={{ width: '180px', height: '70px', marginBottom: '10px' }} alt="" />
        </div>
        <div
          style={{
            padding: '3px 7px',
            borderRadius: '12px',
            border: `2px solid ${borderColor}`,
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: 'column',
            backgroundColor: `${bgColor}`,
            marginRight: '50px',
          }}
        >
          <div style={{ display: 'flex', gap: '30px' }}>
            <div>
              <div
                style={{
                  textAlign: 'left',
                  fontSize: '9px',
                  fontWeight: '600',
                  color: '#000000',
                }}
              >
                TAI Services, Inc.
              </div>
              <div style={{
                textAlign: 'left',
                fontSize: '9px',
                fontWeight: '600',
                color: '#000000',
              }}
              >
                1000 Cobb Place Boulevard NW
              </div>
              <div style={{
                textAlign: 'left',
                fontSize: '9px',
                fontWeight: '600',
                color: '#000000',
              }}
              >
                Bldg 300 Suite 300
              </div>
              <div style={{
                textAlign: 'left',
                fontSize: '9px',
                fontWeight: '600',
                color: '#000000',
              }}
              >
                Kennesaw GA 30144
              </div>
            </div>
            <div>
              <div style={{
                textAlign: 'right',
                fontSize: '9px',
                fontWeight: '600',
                color: '#000000',
              }}
              >
                Phone: (770) 763-5930
              </div>
              <div style={{
                textAlign: 'right',
                fontSize: '9px',
                fontWeight: '600',
                color: '#000000',
              }}
              >
                (800) 554-4127
              </div>
              <div style={{
                textAlign: 'right',
                fontSize: '9px',
                fontWeight: '600',
                color: '#000000',
              }}
              >
                West Coast: (800) 763-3899
              </div>
              <div style={{
                textAlign: 'right',
                fontSize: '9px',
                fontWeight: '600',
                color: '#000000',
              }}
              >
                Fax: (770) 763-5935
              </div>
              <div style={{
                textAlign: 'right',
                fontSize: '9px',
                fontWeight: '600',
                color: '#000000',
              }}
              >
                (800) 591-6860
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', gap: '15px' }}>
            <div style={{
              textAlign: 'left',
              fontSize: '9px',
              fontWeight: '600',
              color: '#000000',
              display: 'flex',
              alignItems: 'center',
            }}
            >
              Sales:
              <a href={`mailto:${emailAddress}`} style={{ textDecoration: 'none' }} onClick={handleEmailClick}>support@taiservices.com</a>
            </div>
            <div style={{
              textAlign: 'right',
              fontSize: '9px',
              fontWeight: '600',
              color: '#000000',
              display: 'flex',
              alignItems: 'center',
            }}
            >
              Web:
              <a href="www.taiservices.com" style={{ textDecoration: 'none' }}>www.taiservices.com</a>
            </div>
          </div>
        </div>
      </div>
      <div style={{ display: 'flex', width: '100%', gap: '10px' }}>
        <div style={{ width: '25%', marginTop: '20px', paddingLeft: '30px' }}>
          <div style={{
            fontSize: '10px', fontWeight: '700', color: '#000000', textAlign: 'center',
          }}
          >
            {` UIN ${oilReportPdfData?.PdfOtherDetails?.UinNumber}`}
          </div>
          <div
            style={{
              fontSize: '9px', fontWeight: '600', color: '#000000', textAlign: 'center',
            }}
          >
            {`Kit #: ${oilReportPdfData?.PdfOtherDetails?.KitNumber}`}
          </div>
          <div
            style={{
              padding: '5px 5px',
              border: `2px solid ${borderColor}`,
              display: 'flex',
              gap: '2px',
              flexDirection: 'column',
              backgroundColor: `${bgColor}`,
            }}
          >
            <div style={{
              fontSize: '10px', fontWeight: '700', color: '#000000',
            }}
            >
              {oilReportPdfData?.PdfOtherDetails?.ReportName}
            </div>
            <div style={{
              fontSize: '10px', fontWeight: '700', color: '#000000',
            }}
            >
              {`Unit No. ${oilReportPdfData?.PdfOtherDetails?.UnitNumber}`}
            </div>
            <div style={{
              display: 'flex', alignItems: 'center', width: '100%', height: '2px', backgroundColor: `${borderColor}`,
            }}
            />
            <div style={{
              fontSize: '10px', fontWeight: '700', color: '#000000',
            }}
            >
              Unit:
            </div>
            <div style={{
              fontSize: '9px', fontWeight: '600', color: '#000000',
            }}
            >
              {`Make: ${oilReportPdfData?.PdfOtherDetails?.UnitMake}`}
            </div>
            <div style={{
              fontSize: '9px', fontWeight: '600', color: '#000000',
            }}
            >
              {`Model: ${oilReportPdfData?.PdfOtherDetails?.UnitModel}`}
            </div>
            <div style={{
              fontSize: '9px', fontWeight: '600', color: '#000000',
            }}
            >
              {`Serial No.:  ${oilReportPdfData?.PdfOtherDetails?.UnitSerialNumber}`}
            </div>
            <div style={{
              fontSize: '9px', fontWeight: '600', color: '#000000',
            }}
            >
              {`Site: ${oilReportPdfData?.PdfOtherDetails?.UnitSite}`}
            </div>
            <div style={{
              display: 'flex', alignItems: 'center', width: '100%', height: '2px', backgroundColor: `${borderColor}`,
            }}
            />
            <div style={{
              fontSize: '10px', fontWeight: '700', color: '#000000',
            }}
            >
              Compartment:
            </div>
            <div style={{
              fontSize: '9px', fontWeight: '600', color: '#000000',
            }}
            >
              {`Name: ${oilReportPdfData?.PdfOtherDetails?.CompName}`}
            </div>
            <div style={{
              fontSize: '9px', fontWeight: '600', color: '#000000',
            }}
            >
              {`Make: ${oilReportPdfData?.PdfOtherDetails?.CompMake}`}
            </div>
            <div style={{
              fontSize: '9px', fontWeight: '600', color: '#000000',
            }}
            >
              {`Model: ${oilReportPdfData?.PdfOtherDetails?.CompModel}`}
            </div>
            <div style={{
              fontSize: '9px', fontWeight: '600', color: '#000000',
            }}
            >
              {`Serial No.: ${oilReportPdfData?.PdfOtherDetails?.CompSerialNumber}`}
            </div>
            {/* <div style={{
              fontSize: '10px', fontWeight: '600', color: '#000000',
            }}
            >
              {`Capacity: ${oilReportPdfData?.PdfOtherDetails?.CompCapacity || ''}`}
            </div> */}
          </div>
          <div
            style={{
              marginTop: '5px',
              padding: '5px 5px',
              border: `2px solid ${borderColor}`,
              display: 'flex',
              gap: '2px',
              flexDirection: 'column',
              backgroundColor: `${bgColor}`,
            }}
          >
            <div style={{
              fontSize: '10px', fontWeight: '600', color: '#000000', display: 'flex', justifyContent: 'center',
            }}
            >
              {`Customer: ${oilReportPdfData?.PdfOtherDetails?.CustomerId}`}
            </div>
            <div style={{
              fontSize: '9px', fontWeight: '650', color: '#000000',
            }}
            >
              {oilReportPdfData?.PdfOtherDetails?.CustomerName}
            </div>
            <div style={{
              fontSize: '9px', fontWeight: '650', color: '#000000',
            }}
            >
              {oilReportPdfData?.PdfOtherDetails?.CustomerAddress}
            </div>
          </div>
          <div
            style={{
              marginTop: '5px',
              padding: '5px 5px',
              border: `2px solid ${borderColor}`,
              display: 'flex',
              gap: '5px',
              flexDirection: 'column',
              backgroundColor: `${bgColor}`,
            }}
          >
            <div style={{
              fontSize: '10px',
              fontWeight: '800',
              color: '#000000',
              display: 'flex',
              justifyContent: 'center',
              borderBottom: `1px solid ${borderColor}`,
            }}
            >
              Diagnosis
            </div>
            <div style={{
              fontSize: '9px', fontWeight: '650', color: '#000000',
            }}
            >
              {oilReportPdfData?.PdfOtherDetails?.Diagnosis}
            </div>
          </div>
        </div>
        <div className="OilReportPdfModal_body_right">
          <TableContainer>
            <Table aria-label="simple table">
              <TableBody>
                <TableRow>
                  <TableCell sx={{ border: `2px solid ${borderColor}`, padding: '5px' }} component="th" scope="row">
                    <div
                      style={{
                        textAlign: 'left', fontSize: '9px', fontWeight: '700', color: '#000000',
                      }}
                    >
                      Date Sampled
                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '700', color: '#000000',
                    }}
                    >
                      Date Received
                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '700', color: '#000000',
                    }}
                    >
                      Date Reported
                    </div>
                  </TableCell>
                  {oilReportPdfData?.TableData?.map((row) => (
                    <TableCell sx={{ border: `2px solid ${borderColor}`, padding: '5px' }}>
                      <div style={{
                        textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                      }}
                      >
                        {row?.DateSampled?.Value}
                      </div>
                      <div style={{
                        textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                      }}
                      >
                        {row?.DateReceived?.Value}
                      </div>
                      <div style={{
                        textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                      }}
                      >
                        {row?.DateReported?.Value}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{ border: `2px solid ${borderColor}`, padding: '5px' }}
                    component="th"
                    scope="row"
                  >
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '700', color: '#000000',
                    }}
                    >
                      Lab No.
                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '700', color: '#000000',
                    }}
                    >
                      SIF No.
                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '700', color: '#000000',
                    }}
                    >
                      Time on Unit (Hrs)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '700', color: '#000000',
                    }}
                    >
                      Time on Oil (Hrs)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '700', color: '#000000',
                    }}
                    >
                      Oil Brand

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '700', color: '#000000',
                    }}
                    >
                      Oil Type

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '700', color: '#000000',
                    }}
                    >
                      Oil Grade

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '700', color: '#000000',
                    }}
                    >
                      Oil Added

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '700', color: '#000000',
                    }}
                    >
                      Filter

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '700', color: '#000000',
                    }}
                    >
                      Oil Changed

                    </div>
                    {/* <div style={{
                      textAlign: 'left', fontSize: '10px', fontWeight: '700', color: '#000000',
                    }}
                    >
                      WO Number

                    </div> */}
                  </TableCell>
                  {oilReportPdfData?.TableData?.map((row) => (
                    <TableCell sx={{
                      border: `2px solid ${borderColor}`, padding: '5px', width: '118px', maxWidth: '118px',
                    }}
                    >
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.LabNo?.Value || '-'}
                        {getDotStyle(row?.LabNo?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.SifNo?.Value || '-'}
                        {getDotStyle(row?.SifNo?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.TimeonUnit?.Value || '-'}
                        {getDotStyle(row?.TimeonUnit?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.TimeonOil?.Value || '-'}
                        {getDotStyle(row?.TimeonOil?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.OilBrand?.Value || '-'}
                        {getDotStyle(row?.OilBrand?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                          whiteSpace: 'nowrap',
                        }}
                      >
                        {row?.OilType?.Value || '-'}
                        {getDotStyle(row?.OilType?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.OilGrade?.Value || '-'}
                        {getDotStyle(row?.OilGrade?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.OilAdded?.Value || '-'}
                        {getDotStyle(row?.OilAdded?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Filter?.Value || '-'}
                        {getDotStyle(row?.Filter?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.OilChanged?.Value || '-'}
                        {getDotStyle(row?.OilChanged?.Color)}
                      </div>
                      {/* <div
                        style={{
                          textAlign: 'left',
                          fontSize: '10px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.WoNumber?.Value || '-'}
                        {getDotStyle(row?.WoNumber?.Color)}
                      </div> */}
                    </TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{ border: `2px solid ${borderColor}`, padding: '5px' }}
                    component="th"
                    scope="row"
                  >
                    <div
                      style={{
                        textAlign: 'left', fontSize: '10px', fontWeight: '700',
                      }}
                    >
                      Metals (ppm)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Iron (Fe)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Chromium (Cr)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Lead (Pb)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Copper (Cu)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Tin (Sn)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Aluminum (Al)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Nickel (Ni)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Silver (Ag)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Titanium (Ti)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Vanadium (V)

                    </div>
                  </TableCell>
                  {oilReportPdfData?.TableData?.map((row) => (
                    <TableCell sx={{ border: `2px solid ${borderColor}`, padding: '5px' }}>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {'\u00A0'}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Iron?.Value || '-'}
                        {getDotStyle(row?.Iron?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Chromium?.Value || '-'}
                        {getDotStyle(row?.Chromium?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Lead?.Value || '-'}
                        {getDotStyle(row?.Lead?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Copper?.Value || '-'}
                        {getDotStyle(row?.Copper?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Tin?.Value || '-'}
                        {getDotStyle(row?.Tin?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Aluminum?.Value || '-'}
                        {getDotStyle(row?.Aluminum?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Nickel?.Value || '-'}
                        {getDotStyle(row?.Nickel?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Silver?.Value || '-'}
                        {getDotStyle(row?.Silver?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Titanium?.Value || '-'}
                        {getDotStyle(row?.Titanium?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Vanadium?.Value || '-'}
                        {getDotStyle(row?.Vanadium?.Color)}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{ border: `2px solid ${borderColor}`, padding: '5px' }}
                    component="th"
                    scope="row"
                  >
                    <div
                      style={{
                        textAlign: 'left',
                        fontSize: '10px',
                        fontWeight: '700',
                      }}
                    >
                      Contaminants (ppm)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Silicon (Si)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Sodium (Na)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Potassium (K)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Water by Karl Fischer (PPM)

                    </div>
                  </TableCell>
                  {oilReportPdfData?.TableData?.map((row) => (
                    <TableCell sx={{ border: `2px solid ${borderColor}`, padding: '5px' }}>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {'\u00A0'}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Silicon?.Value || '-'}
                        {getDotStyle(row?.Silicon?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Sodium?.Value || '-'}
                        {getDotStyle(row?.Sodium?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Potassium?.Value || '-'}
                        {getDotStyle(row?.Potassium?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.WaterByKarlFischer?.Value || '-'}
                        {getDotStyle(row?.WaterByKarlFischer?.Color)}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{ border: `2px solid ${borderColor}`, padding: '5px' }}
                    component="th"
                    scope="row"
                  >
                    <div
                      style={{
                        textAlign: 'left',
                        fontSize: '10px',
                        fontWeight: '700',
                      }}
                    >
                      Additives (ppm)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Magnesium (Mg)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Calcium (Ca)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Barium (Ba)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Phosphoros (P)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Zinc (Zn)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Molybdenum (Mo)

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Boron (B)

                    </div>
                  </TableCell>
                  {oilReportPdfData?.TableData?.map((row) => (
                    <TableCell sx={{ border: `2px solid ${borderColor}`, padding: '5px' }}>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {'\u00A0'}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Magnesium?.Value || '-'}
                        {getDotStyle(row?.Magnesium?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Calcium?.Value || '-'}
                        {getDotStyle(row?.Calcium?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Barium?.Value || '-'}
                        {getDotStyle(row?.Barium?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Phosphorus?.Value || '-'}
                        {getDotStyle(row?.Phosphorus?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Zinc?.Value || '-'}
                        {getDotStyle(row?.Zinc?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Molybdenum?.Value || '-'}
                        {getDotStyle(row?.Molybdenum?.Color)}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Boron?.Value || '-'}
                        {getDotStyle(row?.Boron?.Color)}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <TableCell sx={{ border: `2px solid ${borderColor}`, padding: '5px' }} component="th" scope="row">
                    <div
                      style={{
                        textAlign: 'left', fontSize: '10px', fontWeight: '700',
                      }}
                    >
                      Physical Tests

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Viscosity (cSt 40C)

                    </div>
                    {/* <div style={{
                        textAlign: 'left', fontSize: '10px', fontWeight: '600', color: '#000000',
                      }}>Solids (%)</div> */}
                  </TableCell>
                  {oilReportPdfData?.TableData?.map((row) => (
                    <TableCell sx={{ border: `2px solid ${borderColor}`, padding: '5px' }}>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {'\u00A0'}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.Viscosity?.Value || '-'}
                        {getDotStyle(row?.Viscosity?.Color)}
                      </div>
                      {/* <div style={{
                        textAlign: 'left', fontSize: '10px', fontWeight: '600', color: '#000000',
                      }}>{row?.Solids?.Value}</div> */}
                    </TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{ border: `2px solid ${borderColor}`, padding: '5px' }}
                    component="th"
                    scope="row"
                  >
                    <div
                      style={{
                        textAlign: 'left', fontSize: '10px', fontWeight: '700',
                      }}
                    >
                      Physical/Chemical

                    </div>
                    <div style={{
                      textAlign: 'left', fontSize: '9px', fontWeight: '600', color: '#000000',
                    }}
                    >
                      &nbsp;&nbsp;&nbsp;Acid Number (mgKOH/g)

                    </div>
                  </TableCell>
                  {oilReportPdfData?.TableData?.map((row) => (
                    <TableCell sx={{ border: `2px solid ${borderColor}`, padding: '5px' }}>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {'\u00A0'}
                      </div>
                      <div
                        style={{
                          textAlign: 'left',
                          fontSize: '9px',
                          fontWeight: '600',
                          color: '#000000',
                          display: 'flex',
                          justifyContent: 'space-evenly',
                          alignItems: 'center',
                          flexDirection: 'row',
                        }}
                      >
                        {row?.AcidNumber?.Value || '-'}
                        {getDotStyle(row?.AcidNumber?.Color)}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
                <TableRow>
                  <TableCell
                    sx={{ border: 'none', padding: '3px' }}
                    component="th"
                    scope="row"
                  >
                    <div className="OilReportPdfModal_body_right_buttonContainer_column">
                      <div style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '10px', fontWeight: '600', paddingRight: '10px',
                      }}
                      >
                        Caution
                        <div
                          style={{
                            width: '10px',
                            height: '10px',
                            border: '1px solid #000000',
                            borderRadius: '50%',
                            background: 'yellow',
                            marginLeft: '34px',
                          }}
                        />
                      </div>
                      <div style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '10px', fontWeight: '600', paddingRight: '10px',
                      }}
                      >
                        Abnormal
                        <div style={{
                          width: '10px',
                          height: '10px',
                          border: '1px solid #000000',
                          borderRadius: '50%',
                          background: 'blue',
                          marginLeft: '20px',
                        }}
                        />
                      </div>
                      <div style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '10px', fontWeight: '600', paddingRight: '10px',
                      }}
                      >
                        Severe
                        <div style={{
                          width: '10px',
                          height: '10px',
                          border: '1px solid #000000',
                          borderRadius: '50%',
                          background: 'red',
                          marginLeft: '40px',
                        }}
                        />
                      </div>
                      <div style={{
                        display: 'flex', alignItems: 'center', justifyContent: 'space-between', fontSize: '10px', fontWeight: '600', paddingRight: '10px',
                      }}
                      >
                        Undetermined
                        <div style={{
                          width: '10px',
                          height: '10px',
                          border: '1px solid #000000',
                          borderRadius: '50%',
                          background: 'white',
                          marginLeft: '40px',
                        }}
                        />
                      </div>
                    </div>
                  </TableCell>
                  {oilReportPdfData?.TableData?.map((row) => (
                    <TableCell sx={{ border: 'none', padding: '3px' }}>
                      {renderIcon(row)}
                    </TableCell>
                  ))}
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  );

  const oilReportThirdPage = () => (
    <div style={{ padding: '20px 30px 20px 30px' }}>
      <div
        className="OilReportPdfModal_heading"
        style={{
          fontSize: '20px', fontWeight: '600', textAlign: 'center', marginBottom: '5px',
        }}
      >
        Explanation of Analysis
      </div>
      <div style={{
        textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#000000', marginBottom: '5px',
      }}
      >
        (TEST RESULTS ARE NORMAL UNLESS SPECIFIED OTHERWISE)
      </div>
      {getRectangularComponent({ leftHeading: 'Physical Data', rightHeading: 'Solids % Volume' })}
      <div style={{
        textAlign: 'left', fontSize: '12px', lineHeight: '13px', fontWeight: '600', color: '#000000', marginBottom: '10px', marginTop: '5px',
      }}
      >
        {SOLID_PERCENTAGE}
      </div>
      <div style={{
        textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#000000', marginBottom: '5px',
      }}
      >
        Metal Concentrations in Parts per Million by Weight
      </div>
      <TableContainer sx={{ margin: '5px 0px', padding: '0px 2px' }}>
        <Table aria-label="simple table" style={{ backgroundColor: `${bgColor}` }}>
          <TableHead>
            <TableRow>
              <TableCell
                padding="normal"
                style={{
                  textAlign: 'center', fontSize: '12px', lineHeight: '3px', fontWeight: '700', color: '#000000',
                }}
                sx={{ border: `2px solid ${borderColor}` }}
              >
                Element
              </TableCell>
              <TableCell
                style={{
                  textAlign: 'center', fontSize: '12px', lineHeight: '3px', fontWeight: '700', color: '#000000',
                }}
                sx={{ border: `2px solid ${borderColor}` }}
              >
                Component

              </TableCell>
              <TableCell
                style={{
                  textAlign: 'center', fontSize: '12px', lineHeight: '3px', fontWeight: '700', color: '#000000',
                }}
                sx={{ border: `2px solid ${borderColor}` }}
              >
                Element

              </TableCell>
              <TableCell
                style={{
                  textAlign: 'center', fontSize: '12px', lineHeight: '3px', fontWeight: '700', color: '#000000',
                }}
                sx={{ border: `2px solid ${borderColor}` }}
              >
                Component

              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {LeftElementAndComponent?.map((row) => (
              <TableRow
                key={row?.FirstElement}
              >
                <TableCell
                  style={{
                    textAlign: 'center', fontSize: '12px', lineHeight: '3px', fontWeight: '600', color: '#000000',
                  }}
                  sx={{ border: `2px solid ${borderColor}` }}
                  component="th"
                  scope="row"
                >
                  {row?.FirstElement}
                </TableCell>
                <TableCell
                  style={{
                    textAlign: 'center', fontSize: '12px', lineHeight: '3px', fontWeight: '600', color: '#000000',
                  }}
                  sx={{ border: `2px solid ${borderColor}` }}
                >
                  {row?.FirstComponent}
                </TableCell>
                <TableCell
                  style={{
                    textAlign: 'center', fontSize: '12px', lineHeight: '3px', fontWeight: '600', color: '#000000',
                  }}
                  sx={{ border: `2px solid ${borderColor}` }}
                  component="th"
                  scope="row"
                >
                  {row?.SecondElement}
                </TableCell>
                <TableCell
                  style={{
                    textAlign: 'center', fontSize: '12px', lineHeight: '3px', fontWeight: '600', color: '#000000',
                  }}
                  sx={{ border: `2px solid ${borderColor}` }}
                >
                  {row?.SecondComponent}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{
        textAlign: 'left', fontSize: '12px', lineHeight: '13px', fontWeight: '600', color: '#000000', marginTop: '5px', marginBottom: '10px',
      }}
      >
        {METAL_CONCENTRATIONS}
      </div>
      <div style={{
        textAlign: 'left', fontSize: '12px', fontWeight: '600', color: '#000000', marginBottom: '5px',
      }}
      >
        Additional Physical Information
      </div>
      {getRectangularComponent({ leftHeading: 'VIC (Viscosity)', rightHeading: 'Oil Weight' })}
      <div style={{
        textAlign: 'left', fontSize: '12px', lineHeight: '13px', fontWeight: '600', color: '#000000', marginBottom: '10px', marginTop: '5px',
      }}
      >
        {VISCOSITY_DESCRIPTION}
      </div>
      {getRectangularComponent({ leftHeading: 'WKF (Water Karl Fisher)', rightHeading: 'Water Content' })}
      <div style={{
        textAlign: 'left', fontSize: '12px', lineHeight: '13px', fontWeight: '600', color: '#000000', marginBottom: '10px', marginTop: '5px',
      }}
      >
        {WATER_DESCRIPTION}
      </div>
      {getRectangularComponent({ leftHeading: 'TAN (Total Acid Number)', rightHeading: 'Oil Acidity' })}
      <div style={{
        textAlign: 'left', fontSize: '12px', lineHeight: '13px', fontWeight: '600', color: '#000000', marginBottom: '10px', marginTop: '5px',
      }}
      >
        {TOTAL_ACID_DESCRIPTION}
      </div>
    </div>
  );

  const oilReportSecondPage = () => (
    <div>
      <div style={{
        marginTop: '30px',
        marginBottom: '30px',
        padding: '30px 0px',
      }}
      >
        {/* <div style={{
          width: '50%', alignItems: 'center', justifyContent: 'center', marginBottom: '25px',
        }}
        >
          <img src={oilReportPdfData?.ColorDetails?.LogoLink} style={{ width: '250px', height: '100px' }} alt="" />
        </div> */}
        <div
          className="OilReportPdfModal_heading"
          style={{
            fontSize: '25px', fontWeight: '600', textAlign: 'center', marginBottom: '10px',
          }}
        >
          {oilReportPdfData?.ChartDetails?.Chart1?.[0]?.Name}
        </div>
        <div style={{ width: '70%', alignItems: 'center' }}>
          <ChartComponent
            data={oilReportPdfData?.ChartDetails?.Chart1}
            xKey="Date"
            bar1Key="Viscosity"
            bar1Color="#FF9966"
          />
        </div>
      </div>
      <div
        className="OilReportPdfModal_heading"
        style={{
          fontSize: '25px', fontWeight: '600', textAlign: 'center', marginBottom: '10px',
        }}
      >
        {oilReportPdfData?.ChartDetails?.Chart2?.[0]?.Name}
      </div>
      <div style={{ width: '70%', marginBottom: '20px', alignItems: 'center' }}>
        <ChartComponent
          data={oilReportPdfData?.ChartDetails?.Chart2}
          xKey="Date"
          bar1Key="Chromium"
          bar2Key="Iron"
          bar1Color="#5a96dc"
          bar2Color="#c8e65a"
        />
      </div>
      <div
        className="OilReportPdfModal_heading"
        style={{
          fontSize: '25px', fontWeight: '600', textAlign: 'center', marginBottom: '10px', marginTop: '100px', paddingTop: '30px',
        }}
      >
        {oilReportPdfData?.ChartDetails?.Chart3?.[0]?.Name}
      </div>
      <div style={{
        width: '70%', marginBottom: '20px', alignItems: 'center',
      }}
      >
        <ChartComponent
          data={oilReportPdfData?.ChartDetails?.Chart3}
          xKey="Date"
          bar1Key="AcidNumberKoh"
          bar1Color="#9999ff"
        />
      </div>
      <div
        className="OilReportPdfModal_heading"
        style={{
          fontSize: '25px', fontWeight: '600', textAlign: 'center', marginBottom: '10px', paddingTop: '10px',
        }}
      >
        {oilReportPdfData?.ChartDetails?.Chart4?.[0]?.Name}
      </div>
      <div style={{
        width: '70%', marginBottom: '20px', alignItems: 'center',
      }}
      >
        <ChartComponent
          data={oilReportPdfData?.ChartDetails?.Chart4}
          xKey="Date"
          bar1Key="Copper"
          bar2Key="Lead"
          bar3Key="Tin"
          bar1Color="#ff0000"
          bar2Color="#008000"
          bar3Color="#ffff00"
        />
      </div>
      <div
        className="OilReportPdfModal_heading"
        style={{
          fontSize: '25px', fontWeight: '600', textAlign: 'center', marginBottom: '10px', marginTop: '100px', paddingTop: '30px',
        }}
      >
        {oilReportPdfData?.ChartDetails?.Chart5?.[0]?.Name}
      </div>
      <div style={{
        width: '70%', marginBottom: '10px', alignItems: 'center',
      }}
      >
        <ChartComponent
          data={oilReportPdfData?.ChartDetails?.Chart5}
          xKey="Date"
          bar1Key="Aluminium"
          bar2Key="Sodium"
          bar3Key="Silicon"
          bar1Color="#CCFFFF"
          bar2Color="#FFFFCC"
          bar3Color="#CCCCFF"
        />
      </div>
    </div>
  );

  // const handleRemoveSecondPage = () => (
  //   <div>
  //     <div style={{
  //       marginTop: '200px',
  //       marginBottom: '50px',
  //       padding: '10px 0px',
  //     }}
  //     >
  //       <div style={{
  //         minWidth: '60%', alignItems: 'center', height: '10px', visibility: 'hidden',
  //       }}
  //       >
  //         <ChartComponent
  //           data={oilReportPdfData?.ChartDetails?.Chart1}
  //           xKey="Date"
  //           bar1Key="Viscosity"
  //           bar1Color="#FF9966"
  //         />
  //       </div>
  //     </div>
  //   </div>
  // );
  return (
    <div
      ref={ref}
      style={{
        backgroundColor: '#FFFFFF',
        padding: '10px',
        margin: '0 auto',
      }}
    >
      {oilReportFirstPage()}
      {oilReportPdfData && oilReportPdfData?.TableData?.length > 1 && oilReportSecondPage()}
      {/* {oilReportPdfData && oilReportPdfData?.TableData?.length > 1 ? oilReportSecondPage() : handleRemoveSecondPage()} */}
      <div style={{ marginTop: oilReportPdfData && oilReportPdfData?.TableData?.length > 1 ? '440px' : '30px' }} />
      {oilReportThirdPage()}
    </div>
  );
});

export default OilReportPdfModal;
